module.exports = __webpack_public_path__ + "img/02a-15px_15px.f2f8932d.png";